
import { Component, Vue, Prop } from "vue-property-decorator";

// 面试链接
@Component({
  components: {}
})
export default class ContactModal extends Vue {
  @Prop({ type: String, default: "" }) link!: string;
  name = "contact-modal";
}
